import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DecisionStudioGoUsage = lazy(() =>
  import("@scenes/DecisionStudioGoUsage").then((module) => ({
    default: module.DecisionStudioGoUsage,
  }))
);

export const decisionStudioGoNRO: NavigationRoutingObject = {
  section: "settings",
  Component: DecisionStudioGoUsage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("decision-studio-go-nro-heading", "Decision Studio Go"),
  pageNameForTracking: () => "Decision Studio Go",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) =>
    featureOn("offerfit_dashboard") &&
    featureOn("ds_go_billing_tab") &&
    hasPermission("appGroup", {
      permission: "viewBilling",
    }),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
